// extracted by mini-css-extract-plugin
module.exports = {"albumPage":"albumPage_albumPage__ltUez","albumList":"albumPage_albumList__OO5iX","listEnd":"albumPage_listEnd__JuhiP"};